import { FiUsers } from "react-icons/fi";
import MenuItem from "./MenuItem";
import { IoMdBusiness } from "react-icons/io";
import { MdOutlineFormatListBulleted } from "react-icons/md";
import { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";

export default function MenuWrapper() {
  const { auth } = useContext(AuthContext);
  const menus = [
    {
      id: 1,
      name: "Dashboard",
      to: "/dashboard",
      icon: <MdOutlineFormatListBulleted />,
      access: [4, 5, 9],
    },
    {
      id: 2,
      name: "Requests",
      to: "/requests",
      icon: <MdOutlineFormatListBulleted />,
      access: [1, 2, 3, 4, 5, 9],
    },
    {
      id: 3,
      name: "Businesses",
      to: "/businesses",
      icon: <IoMdBusiness />,
      access: [4, 5, 9],
    },
    {
      id: 4,
      name: "Customers",
      to: "/customers",
      icon: <FiUsers />,
      access: [4, 5, 9],
    },
  ];
  return (
    <div className=" bg-blue-50 border-b py-2 flex px-2">
      {menus?.map((menu: any, index: number) => {
        if (menu?.access?.includes(auth?.accessLevel)) {
          return <MenuItem key={index} menu={menu} />;
        }
      })}
    </div>
  );
}
